/* ============================================================
   ISADORA MAE — cart drawer logic for Dawn
   Tiered discounts + shipping insurance + live totals.
   Ported from the Impulse build.
   ============================================================ */
(function () {
  'use strict';

  var INSURANCE_PENCE = 495; // £4.95
  var INSURANCE_VARIANT_ID = 55252997701975; // hidden 'Shipping Insurance' product line
  var INS_OFF_KEY = 'isa_ins_off';
  var TAG_SVG = '<svg width="10" height="10" viewBox="0 0 20 20" fill="currentColor" style="flex-shrink:0;"><path d="M17.5 8.5l-8-8A1 1 0 008.086.5H2A1.5 1.5 0 00.5 2v6.086a1 1 0 00.293.707l8 8a1 1 0 001.414 0l7.293-7.293a1 1 0 000-1.414zM4.5 6a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"/></svg>';

  var currentTierDiscountPence = 0;
  var currentCartTotalPence = 0;
  var currentRealCount = 0;

  function formatGBP(pence) {
    return '£' + (pence / 100).toFixed(2);
  }

  /* Tier table — identical to the Impulse build */
  function getTierInfo(itemCount) {
    if (itemCount >= 5) return { pct: 25, label: '25% EXTRA OFF 5+ ITEMS' };
    if (itemCount >= 4) return { pct: 20, label: '20% EXTRA OFF 4 ITEMS' };
    if (itemCount >= 3) return { pct: 15, label: '15% EXTRA OFF 3 ITEMS' };
    if (itemCount >= 2) return { pct: 10, label: '10% EXTRA OFF 2 ITEMS' };
    return { pct: 0, label: '' };
  }

  function isInsItem(item) { return item.variant_id === INSURANCE_VARIANT_ID || item.product_title === 'Shipping Insurance'; }
  function realItems(cart) { return cart.items.filter(function (i) { return !isInsItem(i); }); }
  function realCount(cart) {
    return realItems(cart).reduce(function (n, i) { return n + i.quantity; }, 0);
  }
  function insLine(cart) {
    for (var i = 0; i < cart.items.length; i++) if (cart.items[i].variant_id === INSURANCE_VARIANT_ID) return cart.items[i];
    return null;
  }
  function staleIns(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (isInsItem(it) && it.variant_id !== INSURANCE_VARIANT_ID) return it;
    }
    return null;
  }
  function totalExclInsurance(cart) {
    var l = insLine(cart);
    return cart.total_price - (l ? l.final_line_price : 0);
  }
  function insWanted() {
    var t = document.getElementById('CartInsuranceToggle');
    return t ? t.checked : localStorage.getItem(INS_OFF_KEY) !== '1';
  }

  function updateCount(cart) {
    var el = document.getElementById('IsadoraCartCount');
    if (el) el.textContent = realCount(cart);
  }

  /* Keep the real cart in sync with the toggle: insurance line exists
     iff toggle is on AND there is at least one real item. */
  /* Shopify lists the NEWEST line first, so adding the hidden insurance
     line after a product pushes that product down one position. Dawn's
     qty/remove buttons address lines by position (data-index), so keep
     them in step with the real cart. */
  function reindexRows(cart) {
    document.querySelectorAll('cart-drawer .isa-cart-item[data-key]').forEach(function (row) {
      var key = row.getAttribute('data-key');
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === key) {
          row.querySelectorAll('[data-index]').forEach(function (el) { el.setAttribute('data-index', String(i + 1)); });
          row.id = 'CartDrawer-Item-' + (i + 1);
          break;
        }
      }
    });
  }
  var isaSyncing = false;
  var isaInsPresent = null; // unknown until first /cart.js
  var isaInsInflight = false;
  function syncInsurance(cart) {
    isaInsPresent = !!insLine(cart);
    if (isaSyncing || isaInsInflight) return Promise.resolve(false);
    var line = insLine(cart);
    var want = realCount(cart) > 0 && insWanted();
    var req = null;
    var stale = staleIns(cart);
    if (stale) {
      req = fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: stale.key, quantity: 0 }) });
    } else if (want && !line) {
      req = fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: INSURANCE_VARIANT_ID, quantity: 1 }) });
    } else if (!want && line) {
      req = fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) });
    } else if (want && line && line.quantity !== 1) {
      req = fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 1 }) });
    }
    if (!req) return Promise.resolve(false);
    isaSyncing = true;
    return req.then(function (r) { return r.json(); }).then(function () { return true; })
      .catch(function () { return false; })
      .finally(function () { isaSyncing = false; });
  }

  /* Discount-CODE line (e.g. the 15% SMS code). The footer is intentionally
     not re-rendered by Shopify section HTML (see cart-drawer.js), so this line
     used to keep a stale amount after items were removed (showed -£29.52 for a
     £63.95 item). It is now rebuilt from /cart.js on every refresh, so the
     amount always matches what Shopify really deducts. */
  /* SMS discount CODE: the tier badges ("10% EXTRA OFF 2 ITEMS" etc.) always stay
     visible. When a tier applies, the code gets its own tidy line above the
     insurance block, rebuilt from /cart.js on every refresh (never stale).
     The "Discounts" row only shows when a tier applies (as before). */
  /* The SMS code is limited to product collections (so the shipping-insurance
     line gets no discount), which makes Shopify report it as a LINE-level
     discount instead of cart-level. So read it from the lines' own discounts:
     anything that is not one of the "X% EXTRA OFF" tier titles is the code. */
  function getCodeApplication(cart) {
    var title = null, amount = 0, base = 0;
    realItems(cart).forEach(function (item) {
      var sum = 0;
      (item.discounts || []).forEach(function (d) {
        if (!/EXTRA OFF/i.test(d.title || '')) { sum += d.amount; title = title || d.title; }
      });
      if (sum > 0) { amount += sum; base += item.final_line_price + sum; }
    });
    if (!amount) {
      var apps = (cart.cart_level_discount_applications || []).filter(function (a) {
        return a.type === 'discount_code' && a.total_allocated_amount > 0;
      });
      return apps.length ? apps[0] : null;
    }
    var pct = base ? Math.round((amount / base) * 1000) / 10 : 0;
    return { title: title, total_allocated_amount: amount, value_type: 'percentage', value: String(pct) };
  }
  function codeLabel(app) {
    var pct = app.value_type === 'percentage' ? parseFloat(app.value) : 0;
    return pct > 0 ? (pct % 1 === 0 ? pct.toFixed(0) : pct) + '% OFF' : app.title;
  }
  function renderCodeDiscounts(cart) {
    var footer = document.querySelector('.cart-drawer__footer');
    var holder = footer && footer.firstElementChild;
    if (!holder) return;
    var app = getCodeApplication(cart);
    /* Code line only for 1 item; from 2 items on the tier badges tell the story. */
    if (!app || realCount(cart) >= 2) { holder.innerHTML = ''; return; }
    holder.innerHTML = '<ul class="discounts list-unstyled" role="list"><li class="discounts__discount discounts__discount--end isa-code-discount" style="display:flex;justify-content:space-between;align-items:center;gap:12px;">' +
      '<span style="display:inline-flex;align-items:center;gap:6px;">' + TAG_SVG + ' ' + codeLabel(app).replace(/[&<>"]/g, '') + '</span>' +
      '<span>-' + formatGBP(app.total_allocated_amount) + '</span></li></ul>';
  }

  function updateDiscountRow(cart) {
    renderCodeDiscounts(cart);
    var wrap  = document.getElementById('IsadoraDiscountsWrap');
    var badge = document.getElementById('IsadoraDiscountBadge');
    var amt   = document.getElementById('IsadoraDiscountAmount');
    if (!wrap || !badge || !amt) return;

    var tier = getTierInfo(realCount(cart));
    var codeApp = getCodeApplication(cart);

    /* BUG FOUND live (reported: checkout total didn't match the
       drawer's total): a real Shopify automatic discount named
       "X% EXTRA OFF N ITEMS" - matching this exact tier table - now
       exists in Shopify Admin and is actually applied to the cart by
       Shopify itself, so cart.total_price/item.final_line_price
       already come back from /cart.js with the tier percentage
       deducted. This function used to ALSO compute and subtract
       tierDiscountPence = cart.total_price * tier.pct/100 on top of
       that - double-discounting the number shown in the drawer
       (confirmed live: drawer showed £91.55, the real Shopify
       checkout charged £101.88 for the same cart). Per explicit
       instruction: keep the tiered discounts working, just stop
       subtracting them twice.
       Fix: the "Discounts" row's amount is now simply the gap between
       the compare-at/MSRP total and what the cart will actually
       charge (cart.total_price, which already has Shopify's real
       tier discount baked in) - no separate tier.pct subtraction.
       tier.label/getTierInfo() is kept only for the badge's display
       text ("15% EXTRA OFF 3 ITEMS"), never for arithmetic now. */
    currentTierDiscountPence = 0;

    if (tier.pct > 0) {
      /* Full saving = compare-at total minus what they actually pay.
         cart.items (from /cart.js) has no compare_at_price field on this
         store's API version, so read the per-unit compare-at price from
         each row's data-compare-at-unit attribute (rendered by
         cart-drawer.liquid from item.variant.compare_at_price, which IS
         reliable in Liquid) instead - same fix as updateItemPrices()
         below. */
      var compareTotalPence = realItems(cart).reduce(function (sum, item) {
        var row = document.querySelector('.isa-cart-item[data-key="' + item.key + '"]');
        var compareAtUnit = row ? (parseInt(row.getAttribute('data-compare-at-unit'), 10) || 0) : 0;
        var cap = (compareAtUnit > item.original_price) ? compareAtUnit : item.original_price;
        return sum + cap * item.quantity;
      }, 0);

      var discountPence = compareTotalPence - totalExclInsurance(cart);
      var shownLabel = tier.label;
      badge.innerHTML = TAG_SVG + ' ' + shownLabel;
      amt.textContent = '-' + formatGBP(discountPence);
      wrap.style.display = '';
      var footerEl = wrap.closest('.drawer__footer');
      if (footerEl) footerEl.classList.add('isa-has-discount');
    } else {
      wrap.style.display = 'none';
      var footerEl2 = wrap.closest('.drawer__footer');
      if (footerEl2) footerEl2.classList.remove('isa-has-discount');
    }
  }

  /* Per-item price display: item.final_line_price already includes
     every real Shopify discount applied to this line, INCLUDING the
     "X% EXTRA OFF" tier discount now that it is a real Shopify
     automatic discount (see the long comment in updateDiscountRow
     above for how that was confirmed and why the old "apply tier.pct
     by hand on top of final_line_price" approach here double-counted
     it) - so this function just displays final_line_price as-is, no
     extra arithmetic. */
  function setPriceCol(priceCol, originalPence, salePence, hasDiscount) {
    var row = priceCol.querySelector('.isa-cart-item__price-row');
    var saveDiv = priceCol.querySelector('.isa-cart-item__price-save');
    if (!row) return;

    if (hasDiscount) {
      row.innerHTML =
        '<span class="visually-hidden">Regular price</span>' +
        '<s class="isa-cart-item__price-original">' + formatGBP(originalPence) + '</s>' +
        '<span class="visually-hidden">Sale price</span>' +
        '<span class="isa-cart-item__price-sale">' + formatGBP(salePence) + '</span>';

      if (!saveDiv) {
        saveDiv = document.createElement('div');
        saveDiv.className = 'isa-cart-item__price-save';
        row.insertAdjacentElement('afterend', saveDiv);
      }
      saveDiv.textContent = '(Save ' + formatGBP(originalPence - salePence) + ')';
      saveDiv.style.display = '';
    } else {
      row.innerHTML = '<span class="isa-cart-item__price-sale">' + formatGBP(originalPence) + '</span>';
      if (saveDiv) saveDiv.style.display = 'none';
    }
  }

  function updateItemPrices(cart) {
    var rows = document.querySelectorAll('.isa-cart-item[data-key]');

    rows.forEach(function (row) {
      var key = row.getAttribute('data-key');
      var item = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === key) { item = cart.items[i]; break; }
      }
      if (!item) return;

      var priceCol = row.querySelector('.isa-cart-item__price-col');
      if (!priceCol) return;

      /* Struck-through price must be the variant's true compare-at/MSRP,
         not item.original_line_price (which is only the price before
         CART-level discounts - it's already below MSRP when the variant
         itself carries a product-level sale price). Mirrors the same
         fix made in cart-drawer.liquid's isa_compare_price.
         NOTE: this store's /cart.js response does NOT include a
         compare_at_price field on line items (confirmed live - only
         price/original_price/line_price/etc are present), so it can't
         be read from `item` here. Read it instead from the
         data-compare-at-unit/data-price-unit attributes cart-drawer.liquid
         renders once per row from item.variant.compare_at_price/price
         (which ARE reliably available in Liquid). Without this, a qty
         change re-render (this function) would flash the wrong lower
         "original" price back in even after the Liquid first-paint had
         it right. */
      var compareAtUnit = parseInt(row.getAttribute('data-compare-at-unit'), 10) || 0;
      var priceUnit = parseInt(row.getAttribute('data-price-unit'), 10) || 0;
      var comparePence = (compareAtUnit > priceUnit)
        ? compareAtUnit * item.quantity
        : item.original_line_price;

      if (comparePence !== item.final_line_price) {
        setPriceCol(priceCol, comparePence, item.final_line_price, true);
      } else {
        setPriceCol(priceCol, item.original_line_price, item.final_line_price, false);
      }
    });
  }

  function updateDisplayedTotals() {
    var toggle     = document.getElementById('CartInsuranceToggle');
    var btnPriceEl = document.getElementById('IsadoraBtnPrice');
    var totalEl    = document.querySelector('.totals__total-value');

    /* currentTierDiscountPence is always 0 now (see updateDiscountRow) -
       currentCartTotalPence (cart.total_price) already has Shopify's
       real tier discount baked in, so it is used as-is here instead
       of having the same percentage subtracted from it a second
       time. */
    var insurancePence = (toggle && toggle.checked && currentRealCount > 0) ? INSURANCE_PENCE : 0;
    var displayPence   = currentCartTotalPence - currentTierDiscountPence + insurancePence;
    if (displayPence < 0) displayPence = 0;

    var formatted = formatGBP(displayPence);
    if (btnPriceEl) btnPriceEl.textContent = formatted;
    if (totalEl)    totalEl.textContent    = formatted;
  }

  function refresh() {
    /* Disconnect the drawer MutationObserver (declared below, hoisted
       into scope) before we write to the DOM ourselves, and only
       reconnect once those writes are done - otherwise our own
       updateItemPrices()/setPriceCol() innerHTML writes re-trigger the
       very observer that called refresh() in the first place, looping
       forever. See the long comment above observeDrawer() for the
       full story (confirmed via network trace: 50,000+ /cart.js
       requests from a single "+" click before this fix). */
    if (isaDrawerObserver) isaDrawerObserver.disconnect();
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        currentCartTotalPence = totalExclInsurance(cart);
        currentRealCount = realCount(cart);
        updateCount(cart);
        updateDiscountRow(cart);
        updateItemPrices(cart);
        updateDisplayedTotals();
        reindexRows(cart);
        var isaDrawerNow = document.querySelector('cart-drawer');
        var isaNeedsEmptyFix = realCount(cart) === 0 && isaDrawerNow && (!isaDrawerNow.classList.contains('is-empty') || isaDrawerNow.querySelector('.isa-cart-announcement'));
        syncInsurance(cart).then(function (changed) {
          if (!isaNeedsEmptyFix) {
            /* Just re-read the cart (reindex rows + totals); no DOM
               swap, so the toggle never flickers back and forth. */
            if (changed) { isaSyncing = false; refresh(); }
            return;
          }
          /* Line positions changed (insurance added/removed) - re-render
             the drawer so data-index values match the real cart. */
          fetch('/?sections=cart-drawer')
            .then(function (r) { return r.json(); })
            .then(function (sec) {
              var doc = new DOMParser().parseFromString(sec['cart-drawer'], 'text/html');
              var fresh = doc.querySelector('#CartDrawer');
              var cur = document.querySelector('#CartDrawer');
              if (fresh && cur) cur.innerHTML = fresh.innerHTML;
              var d = document.querySelector('cart-drawer');
              if (d) d.classList.toggle('is-empty', !!doc.querySelector('.drawer__inner-empty'));
            })
            .catch(function () {});
        });
        /* Price text changes (updateItemPrices' innerHTML rewrite) can
           shift row heights slightly - re-measure/re-cap the items box
           after that settles, not just once synchronously in init(). */
        sizeItemsBox();
      })
      .catch(function () { /* cart unavailable — leave the rendered values alone */ })
      .finally(function () {
        if (isaDrawerObserver && isaDrawerEl) {
          isaDrawerObserver.observe(isaDrawerEl, { childList: true, subtree: true });
        }
      });
  }

  function bindInsuranceToggle() {
    var toggle = document.getElementById('CartInsuranceToggle');
    if (!toggle || toggle.dataset.isaBound) return;
    toggle.dataset.isaBound = '1';
    toggle.checked = localStorage.getItem(INS_OFF_KEY) !== '1';
    toggle.addEventListener('change', function () {
      if (toggle.checked) localStorage.removeItem(INS_OFF_KEY); else localStorage.setItem(INS_OFF_KEY, '1');
      updateDisplayedTotals();
      refresh();
    });
  }

  /* Add-to-cart bug fix: Dawn reveals the cart drawer via a CSS
     transition on `visibility` (.drawer { visibility:hidden;
     transition:visibility .2s } / .drawer.active { visibility:visible }).
     When an add-to-cart triggers TWO overlapping DOM rewrites in quick
     succession - cart.js's own onCartUpdate() (a full replaceWith() of
     cart-drawer-items + cart-drawer__footer, fetched separately) and
     then cart-drawer.js's renderContents() (a second, full innerHTML
     swap of the whole .drawer__inner, using the earlier /cart/add.js
     response) - the rapid back-to-back reflows can interrupt the
     visibility transition before the browser ever commits/paints the
     "hidden" starting frame, so it never fires and the drawer (or a
     freshly-replaced row inside it) stays permanently invisible even
     though the .active class is present and correct. Confirmed via
     direct getComputedStyle() testing: class="drawer animate active"
     computed visibility stuck at "hidden" indefinitely (tested 15s+)
     until something else forces a fresh reflow.
     Fix: whenever we already re-check the drawer (every init() call -
     on load, on cart:update/cart:refresh, and on the debounced
     MutationObserver below), force visibility back on with an inline
     style whenever the drawer SHOULD be open. An inline style always
     wins the cascade over the stuck transition state, no animation
     required, so the content appears in one go instead of staying
     blank - matching Impulse, which does not use a CSS transition for
     this at all. */
  function forceDrawerVisible() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (drawer.classList.contains('active')) {
      drawer.style.visibility = 'visible';
    } else {
      drawer.style.visibility = '';
    }
  }

  /* Sizes cart-drawer-items (the scrollable product-list box) to
     exactly the space actually left after the header/announcement bar
     and the footer, via an inline max-height. Doing this in JS instead
     of pure CSS flexbox (flex-grow:1) because flex-basis:auto content
     measurement on a flex item that wraps Dawn's table-based cart
     markup proved unreliable in practice - empirically it sometimes
     shrank the box well below its content with room to spare, and
     other times left a trailing gap instead of shrinking to fit.
     The box ALWAYS gets the full available height (never just enough
     to hug short content - confirmed live against the real Impulse
     cart's .drawer__scrollable, which is flex-grow:1 and behaves the
     same way): few/short items -> box is still full height, with the
     unused space simply sitting blank inside/below the last item row,
     footer follows immediately after with no separate dead gap;
     too many/tall items -> box caps at the real remaining space and
     scrolls internally; footer and checkout always stay fully
     visible/pinned, never pushed off screen or requiring a
     whole-drawer scroll. */
  function sizeItemsBox() {
    var items = document.querySelector('cart-drawer-items');
    var inner = document.querySelector('.drawer__inner');
    var footer = document.querySelector('.drawer__footer');
    if (!items || !inner || !footer) return;

    var prevHeight = items.style.height;

    var innerRect = inner.getBoundingClientRect();
    var itemsRect = items.getBoundingClientRect();
    var itemsTopOffset = itemsRect.top - innerRect.top;
    var footerHeight = footer.getBoundingClientRect().height;

    /* ISADORA: on the drawer's very first open after an add-to-cart
       (drawer was closed, now opening with brand-new content), this
       can run before the fresh .drawer__footer markup has actually
       been laid out - footerHeight reads 0 for that one call even
       though the footer element exists. Subtracting a 0 footer
       height computes an items box far taller than correct (nothing
       reserved for Shipping Insurance/Discounts/Checkout below it),
       which then visibly snaps down to the right size a moment later
       once a subsequent call measures the footer correctly -
       confirmed live: a huge blank gap opened up between the one
       cart item and the footer right after add, then collapsed on
       its own about a second later. Rather than ever commit that
       wrong height, skip this call entirely when the footer hasn't
       been measured yet - the next call (refresh()'s MutationObserver
       cycle fires several more times in quick succession right after
       an add) will run moments later with real numbers. Leaves the
       box exactly as it already was (correct on every call after the
       very first) rather than writing something that needs undoing. */
    if (footerHeight === 0) return;

    /* User explicitly asked for visible breathing room between the
       product list and the footer (Shipping Insurance etc.) instead
       of the two sitting flush/abutted - reserve a fixed gap here so
       .drawer__footer's own margin-top:auto (isadora-brand.css) has
       leftover space to push into, producing a real visible gap
       above the footer at every viewport height, not just on tall
       screens with slack to spare. */
    var FOOTER_GAP = 18;
    var available = inner.clientHeight - itemsTopOffset - footerHeight - FOOTER_GAP;
    if (available < 0) available = 0;

    /* Directly measured the real (unpublished) Impulse cart drawer's
       DOM at a matched tall viewport (920x1220, 2 items in cart) to
       settle this: Impulse's .drawer__scrollable (their equivalent of
       cart-drawer-items) is flex-grow:1 and ALWAYS stretches to fill
       every bit of leftover vertical space, even when the 2 product
       rows inside it are much shorter than that - the "extra" space
       shows up as blank room INSIDE/AT THE BOTTOM of that same
       scrollable box, with the footer sitting flush right after it,
       zero gap. It is NOT `min(contentHeight, available)` (which is
       what this used to compute) - that formula shrinks the box down
       to hug short content, which then strands the footer's
       margin-top:auto pin far below it, opening up a large dead gap
       BETWEEN the items box and the footer on any viewport taller
       than the cart's content (reported live as "still see that white
       space when I scroll down"). Using the raw available height
       unconditionally - never shrinking to content - matches
       Impulse exactly in both directions: short content -> blank
       space stays attached inside the (still full-height) items box,
       directly followed by the footer with no separate gap; tall
       content -> same as before, caps at available and scrolls
       internally. */
    var finalHeight = available;
    if (finalHeight < 0) finalHeight = 0;

    /* Explicit `height`, not `max-height`: max-height is only a
       ceiling - when the cart has few/short items, content is
       naturally shorter than the available space and the box would
       just shrink-wrap to it, reopening the exact dead-gap bug this
       function exists to fix. An explicit height forces the box to
       actually occupy all of the available space every time,
       regardless of content - matching Impulse's flex-grow:1
       .drawer__scrollable, which is a real flex-stretched height, not
       a cap. overflow-y:auto (isadora-brand.css) still scrolls
       internally on the rare case content is taller than this. */
    if (Math.round(finalHeight) + 'px' === prevHeight) {
      items.style.height = prevHeight;
    } else {
      items.style.height = finalHeight + 'px';
    }
  }

  var pendingResizeSize = null;
  window.addEventListener('resize', function () {
    clearTimeout(pendingResizeSize);
    pendingResizeSize = setTimeout(sizeItemsBox, 100);
  });

  /* User reported a colour swatch on a product page (Yellow, on the
     Layla mock-turtleneck sweater) rendering as an empty pale box
     instead of the actual thumbnail photo. Checked the underlying
     data and markup directly: the variant image, the CDN URL, and the
     swatch's inline background-image style were all correct and the
     image loaded fine on request - this points to a one-off slow/
     failed network fetch of that specific thumbnail rather than a
     real bug, which a page refresh alone would already fix. Still,
     product-image-as-swatch (.isadora-img-swatch, product-variant-
     picker.liquid) has no built-in retry, unlike Shopify's native
     swatch feature - a single flaky CDN request leaves it looking
     permanently broken until the visitor reloads. Add a small retry:
     if the swatch's background image fails to decode, try again a
     couple of times with a cache-busting param before giving up (in
     which case the existing neutral #f5f0ea fallback background-color
     on .isadora-img-swatch just stays visible, same as today). */
  function hardenSwatchImages() {
    var swatches = document.querySelectorAll('.isadora-img-swatch[style*="background-image"]');
    swatches.forEach(function (el) {
      if (el.dataset.isaSwatchHardened) return;
      el.dataset.isaSwatchHardened = '1';

      var style = el.getAttribute('style') || '';
      var match = style.match(/background-image:\s*url\(['"]?([^'")]+)['"]?\)/);
      if (!match) return;
      var originalUrl = match[1];

      var attempt = 0;
      function verify(url) {
        attempt++;
        var probe = new Image();
        probe.onload = function () {
          /* Confirmed loadable - make sure the swatch is actually
             showing this exact (possibly retried) URL. */
          el.style.backgroundImage = "url('" + url + "')";
        };
        probe.onerror = function () {
          if (attempt >= 3) return; // give up, keep neutral fallback color
          var retryUrl = originalUrl + (originalUrl.indexOf('?') > -1 ? '&' : '?') + 'isa_retry=' + attempt;
          setTimeout(function () { verify(retryUrl); }, 400 * attempt);
        };
        probe.src = url;
      }
      verify(originalUrl);
    });
  }

  function init() {
    bindInsuranceToggle();
    forceDrawerVisible();
    sizeItemsBox();
    refresh();
    hardenSwatchImages();
  }

  /* Initial load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* CRITICAL BUG FOUND while testing the qty +/- spinner fix above:
     observeDrawer() (below) watches the cart-drawer subtree and calls
     init() -> refresh() on every mutation. But refresh() itself WRITES
     to that same subtree (updateItemPrices()'s setPriceCol() does
     row.innerHTML = ... on every row, every single call, even when the
     price text hasn't actually changed) - which is itself a mutation,
     which re-fires the SAME observer, which calls refresh() again,
     which mutates again... an unthrottled infinite feedback loop. Live
     network trace confirmed this: a single "+" click produced 50,000+
     GET /cart.js requests in about 11 seconds and never stopped on its
     own. This constant request storm competes for connection slots
     with the actual /cart/change.js update, which is almost certainly
     the real cause of the "1-2 second" qty-update delay the user
     reported - not raw network latency at all.
     Fix: disconnect the observer before refresh() writes to the DOM,
     and only reconnect once those writes are done, so our own updates
     can never re-trigger themselves. Genuine external mutations (a
     real subsequent add/remove from Dawn) still get picked up as soon
     as the observer is reconnected. */
  var isaDrawerObserver = null;
  var isaDrawerEl = null;

  function observeDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    isaDrawerEl = drawer;
    var pending = null;
    isaDrawerObserver = new MutationObserver(function () {
      bindInsuranceToggle(); /* instantly restore toggle state after any re-render */
      clearTimeout(pending);
      pending = setTimeout(init, 60);
    });
    isaDrawerObserver.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer);
  } else {
    observeDrawer();
  }

  /* Dawn dispatches this after add-to-cart */
  document.addEventListener('cart:update', init);
  document.addEventListener('cart:refresh', init);

  /* ISADORA: "add to cart" loading overlay.
     Reported: adding a product visibly glitches - the drawer's old
     content disappears and the new content (including every item's
     photo, which has to load fresh since cart-drawer.js's
     renderContents() destroys and recreates the whole item list, not
     just the new row) pops in abruptly, sometimes showing a blank/
     half-loaded state for a moment before everything settles.
     Reference sites named as the target feel (ICON Amsterdam, Lumina
     Wear): clicking "add to cart" shows a brief, deliberate loading
     state over the drawer, then reveals the finished result in one
     clean motion - nothing is ever seen disappearing and reappearing.

     Approach: the instant a product form is submitted (same tick as
     the click, well before the /cart/add response even comes back),
     fade in a spinner overlay positioned over where the drawer panel
     sits. Dawn's own flow then does its thing (fetch -> cart-drawer.js
     renderContents() swaps in the fresh HTML -> drawer slides open) -
     all of that keeps happening exactly as before, it's just hidden
     under the overlay. Once the swapped-in content's images have
     actually finished loading (not just been inserted into the DOM -
     an <img> is in the DOM the instant renderContents() runs, but its
     pixels aren't painted until the browser has fetched/decoded it),
     fade the overlay back out. The drawer is then already fully
     settled - correct scroll position, correct sizing, every photo
     already rendered - so there's nothing left to glitch into place
     in front of the shopper.

     Deliberately scoped to renderContents() only (the add-to-cart /
     quick-add path), not quantity +/- changes in an already-open
     drawer - those are a much smaller, already-fixed update and
     don't need a loading state of their own. */
  var isaOverlayEl = null;
  var isaOverlayHideTimer = null;

  function isaGetOverlay() {
    if (isaOverlayEl && isaOverlayEl.isConnected) return isaOverlayEl;
    var drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl) return null;
    var el = document.createElement('div');
    el.className = 'isa-add-overlay';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<span class="isa-add-overlay__spinner"></span>';
    drawerEl.appendChild(el);
    isaOverlayEl = el;
    return el;
  }

  function isaShowAddOverlay() {
    var el = isaGetOverlay();
    if (!el) return;
    clearTimeout(isaOverlayHideTimer);
    /* Force a reflow before adding the visible class so the opacity
       transition always runs, even if the overlay was just created
       (a freshly-inserted element's first class change can otherwise
       get coalesced with its initial paint and skip the transition). */
    void el.offsetHeight;
    el.classList.add('is-visible');
  }

  function isaHideAddOverlay() {
    if (!isaOverlayEl) return;
    isaOverlayEl.classList.remove('is-visible');
  }

  /* Belt-and-braces: whatever happens (slow network, a render path
     that doesn't go through renderContents, an error), never leave
     the shopper staring at a stuck overlay - force it to hide well
     before this no matter what (see isaWaitForImagesThenHideOverlay's
     own fast-settle timer below, which normally wins first). */
  function isaArmOverlaySafety() {
    clearTimeout(isaOverlayHideTimer);
    isaOverlayHideTimer = setTimeout(function () {
      isaHideAddOverlay();
      /* Add never produced a render (error / sold out): close the
         drawer we opened optimistically on submit. */
      if (!isaRendered && isaOpenedEarly) {
        var d = document.querySelector('cart-drawer');
        if (d && d.close) d.close();
      }
    }, 6000);
  }
  var isaRendered = false;
  var isaOpenedEarly = false;

  document.addEventListener(
    'submit',
    function (event) {
      if (!event.target || !event.target.closest || !event.target.closest('product-form')) return;
      isaRendered = false;
      /* Insurance is ON by default on every add-to-cart, even if the
         shopper switched it off earlier. */
      try { localStorage.removeItem(INS_OFF_KEY); } catch (e) {}
      var isaTg = document.getElementById('CartInsuranceToggle');
      if (isaTg) isaTg.checked = true;
      /* No spinner overlay any more. If the cart already has items, open
         the drawer instantly showing them and let the new row pop in; for
         an empty cart the add button's own small spinner is shown and the
         drawer opens the moment the add succeeds. */
      var d = document.querySelector('cart-drawer');
      isaOpenedEarly = false;
      if (d && d.open && !d.classList.contains('active') && !d.classList.contains('is-empty')) {
        isaOpenedEarly = true;
        d.open();
      }
      isaArmOverlaySafety();
    },
    true
  );

  /* Reported: "it takes way too long before the cart opens" after
     clicking Add to Cart. Root cause - this function used to wait for
     EVERY <img> inside cart-drawer-items to fire a real 'load'/'error'
     event before ever hiding the overlay. cart-drawer.js's
     renderContents() replaces the WHOLE item list's innerHTML on every
     add (see the CartDrawerItems.getSectionsToRender comment above),
     so that is a fresh <img> element for every row already in the
     cart, not just the one just added - each one needs a real network
     round-trip (or at minimum a re-decode) before it reports complete,
     even if the browser's HTTP cache can serve the bytes instantly.
     With more than one item in the cart, or on a slower connection,
     that pushed the visible wait close to (or all the way to) the 3s
     safety ceiling - a real, user-facing multi-second stall, not just
     a one-off glitch.
     Fix: race the real image-load tracking against a short fixed
     settle timer. Fast connections still often finish every image
     before the timer and hide the overlay immediately, same as
     before; anything slower now reveals the drawer after a brief,
     consistent, deliberate-feeling pause instead of an open-ended one
     - remaining images that are still mid-flight simply finish
     painting in behind the now-visible drawer, which is a far smaller
     regression than a multi-second stuck overlay. */
  function isaWaitForImagesThenHideOverlay() {
    var items = document.querySelector('cart-drawer-items');
    var imgs = items ? Array.prototype.slice.call(items.querySelectorAll('img')) : [];
    var pending = imgs.filter(function (img) {
      return !img.complete;
    });

    if (!pending.length) {
      isaHideAddOverlay();
      return;
    }

    var settled = false;
    var remaining = pending.length;

    function settle() {
      remaining--;
      if (remaining <= 0) finish();
    }

    function finish() {
      if (settled) return;
      settled = true;
      isaHideAddOverlay();
    }

    pending.forEach(function (img) {
      img.addEventListener('load', settle, { once: true });
      img.addEventListener('error', settle, { once: true });
    });

    /* Fast-settle ceiling: never make the shopper wait longer than
       this for images alone, regardless of how many rows are in the
       cart or how slow the CDN is right now. */
    setTimeout(finish, 450);
  }

  /* cart-drawer.js's renderContents() is what product-form.js (the
     regular add-to-cart flow) and the quick-add modal both call
     directly to paint the freshly-added cart into the drawer - wrap
     it rather than editing that Dawn core file, so this stays an
     isolated, easily-removable addition. */
  function isaPatchRenderContents(CartDrawerCtor) {
    if (!CartDrawerCtor || CartDrawerCtor.prototype.__isaRenderContentsPatched) return;
    var original = CartDrawerCtor.prototype.renderContents;
    CartDrawerCtor.prototype.renderContents = function () {
      isaRendered = true;
      /* Product add has just succeeded (so insurance lands AFTER it and
         line indexes stay valid): add the hidden insurance line right
         now, without waiting for the refresh/sync chain or a re-render. */
      if (isaInsPresent === false && !isaInsInflight && insWanted()) {
        isaInsInflight = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: INSURANCE_VARIANT_ID, quantity: 1 }) })
          .catch(function () {})
          .finally(function () { isaInsInflight = false; isaInsPresent = true; refresh(); });
      }
      var result = original.apply(this, arguments);
      isaWaitForImagesThenHideOverlay();
      return result;
    };
    CartDrawerCtor.prototype.__isaRenderContentsPatched = true;
  }

  /* BUG FOUND verifying the close()-overlay fix below: neither this
     patch nor isaPatchDrawerOpenClose ever actually ran. Both only
     tried customElements.get('cart-drawer') once, on DOMContentLoaded
     (or immediately, if that had already fired) - a one-shot check
     with no retry. cart-drawer.js registers the <cart-drawer> custom
     element from its own script, and script execution order between
     it and this file is not guaranteed; when isadora-cart.js happened
     to run first, customElements.get('cart-drawer') returned
     undefined, the guard silently bailed, and - because nothing ever
     called these functions again - the patch permanently never
     applied for the rest of that page's lifetime. Confirmed live:
     customElements.get('cart-drawer') was defined moments later, but
     CartDrawerCtor.prototype.__isaRenderContentsPatched /
     __isaOpenClosePatched were both still unset.
     Fix: customElements.whenDefined() resolves once the element is
     actually registered, however the two scripts happen to be
     ordered, and resolves immediately if it already is - the correct
     primitive for this instead of a single synchronous check. */
  customElements.whenDefined('cart-drawer').then(function () {
    isaPatchRenderContents(customElements.get('cart-drawer'));
  });

  /* BUG FOUND while testing the loading-overlay feature above: closing
     the cart drawer (X button, Escape, clicking the backdrop) left a
     full-screen, unclickable dark overlay stuck on screen - the
     shopper could not click anything on the page afterwards.

     Root cause: forceDrawerVisible() (above) is the only thing that
     ever clears the inline `visibility` style it sets, and it is only
     re-run reactively, from cart content mutations - init() on load,
     on the debounced cart-drawer MutationObserver, and on the
     cart:update/cart:refresh events Dawn fires after an add/change.
     Closing the drawer does none of those things: cart-drawer.js's
     close() only removes the "active" class from <cart-drawer> itself
     (an attribute change on the drawer element, not a child mutation,
     so the subtree observer never fires) and does not dispatch
     cart:update or cart:refresh. If the drawer is closed without some
     unrelated cart mutation happening to run afterwards, the inline
     style: visibility:visible that forceDrawerVisible() set while the
     drawer was open is never cleared - it permanently overrides the
     CSS rule that would otherwise hide <cart-drawer> (and its
     rgba(0,0,0,.5) backdrop, which covers the full viewport at
     pointer-events:auto) once "active" is removed.
     Fix: patch open()/close() directly (same approach as
     isaPatchRenderContents above) so forceDrawerVisible() runs the
     instant the drawer's state actually changes, instead of waiting
     on a content-mutation side-channel that doesn't fire on close. */
  function isaPatchDrawerOpenClose(CartDrawerCtor) {
    if (!CartDrawerCtor || CartDrawerCtor.prototype.__isaOpenClosePatched) return;
    var originalOpen = CartDrawerCtor.prototype.open;
    var originalClose = CartDrawerCtor.prototype.close;
    CartDrawerCtor.prototype.open = function () {
      var result = originalOpen.apply(this, arguments);
      forceDrawerVisible();
      return result;
    };
    CartDrawerCtor.prototype.close = function () {
      var result = originalClose.apply(this, arguments);
      forceDrawerVisible();
      return result;
    };
    CartDrawerCtor.prototype.__isaOpenClosePatched = true;
  }

  /* See the long comment above isaPatchRenderContents' whenDefined
     call - same script-order race, same fix. */
  customElements.whenDefined('cart-drawer').then(function () {
    isaPatchDrawerOpenClose(customElements.get('cart-drawer'));
  });

  /* Warm the browser cache with the exact cart-thumbnail URL (same
     width the drawer requests) for the currently selected variant, so
     the cart photo is already there when the drawer opens. */
  var isaPrefetched = {};
  function isaPrefetchCartImage() {
    var el = document.querySelector('script[data-selected-variant]');
    if (!el) return;
    try {
      var v = JSON.parse(el.textContent);
      var src = v && v.featured_image && v.featured_image.src;
      if (!src) return;
      var url = (src.indexOf('//') === 0 ? 'https:' + src : src) + (src.indexOf('?') > -1 ? '&' : '?') + 'width=170';
      if (isaPrefetched[url]) return;
      isaPrefetched[url] = true;
      var img = new Image();
      img.src = url;
    } catch (e) {}
  }
  function isaWatchSelectedVariant() {
    isaPrefetchCartImage();
    var el = document.querySelector('script[data-selected-variant]');
    if (el) new MutationObserver(isaPrefetchCartImage).observe(el, { childList: true, characterData: true, subtree: true });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects')) setTimeout(isaPrefetchCartImage, 400);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', isaWatchSelectedVariant);
  else isaWatchSelectedVariant();
})();
